/**
 * @title Select tradein area
 * @description The frontpage of the tradein app, the user selects whether to use the wholesale or dtc tradein options here
 * @image https://storageaccountourimbea2.blob.core.windows.net/tradein2guide/frontpage.png
 */
import React, {FC, useState} from "react";
import {StyledButton, StyledTypography} from "../../providers/layout/LayoutProvider";
import {PublicRenderer} from "./PublicRenderer";
import {makeStyles} from "@mui/styles";
import {useNavigate} from "react-router-dom";
import {usePublicPageConsumerCreateMutation} from "../../Queries";
import {useRecoilValue, useSetRecoilState} from "recoil";
import {AccessContextData} from "../../providers/access/AppContextProvider";
import {ReturnsPagePath} from "../restricted/returns/ReturnsPage";
import {LocaleAtom, LocalizationsAtom} from "../../providers/localization/LocalizationProvider";
import {TradeInBox} from "./TradeInBox";
import {Images} from "../../Images";
import {AppDataAtom} from "../../providers/access/ApplicationDataProvider";
import {LoginPage, LoginPagePath} from "./LoginPage";
import {MosMoshPage} from "./MosMosh";
import {LesDeuxPage} from "./LesDeux";
import {PompDeLuxPage} from "./PompDeLux";
import {WheatPage} from "./WheatPage";
import {SpejderSportPage} from "./SpejderSportPage";
import {NorthernHuntingPage} from "./NorthernHuntingPage";
import {CountryMapFactory} from "../../utility/CountryMapFactory";
import {LoginContext} from "../LoginContext";
import {MarkbergPage} from "./Markberg";
import {OutfitPage} from "./OutfitPage";
import {LuksusbabyPage} from "./Luksusbaby";
import {SkagenClothingPage} from "./SkagenClothing";
import {ByGreenCottonPage} from "./ByGreenCottonPage";
import {Box} from "@mui/material";
import {MinimumPage} from "./Minimum";
import {RabensPage} from "./Rabens";
import {KintobePage} from "./KintobePage";
import {MoshiPage} from "./MoshiMoshi";
import {RoccamorePage} from "./RoccamorePage";
import {PitayaPage} from "./Pitaya";
import {MoonboonPage} from "./MoonboonPage";
import {LaRougePage} from "./LaRougePage";
import {GaiLisva} from "./GaiLisva";

export const PublicPagePath = () => {
   return "/"
}
export const PublicPage: FC<any> = () => {
   const appData = useRecoilValue(AppDataAtom);
   const appContext = useRecoilValue(AccessContextData);
   const localizations = useRecoilValue(LocalizationsAtom);

   let showLoginOptions = appData.wholeSaleActive || appContext.disableLogin;

   if (appContext.headless) {
      if (localizations.consumerAlmostThereBackToStartUrl) {
         window.location.replace(localizations.consumerAlmostThereBackToStartUrl);
         return <Box/>
      } else {
         return <StyledTypography type={"front"} variant={"h2"}>
            {localizations.headlessCaption}
         </StyledTypography>
      }
   }

   if (appContext.shopId === '6299f8f0521b13e374cb6cc4'
      || appContext.shopId === '6299c67a5c8bfae121f692e0'
      || appContext.shopId === '64196a33597d2f1d27b14780'
      || appContext.shopId === '62711c736207f585302465df') {
      return <MosMoshPage/>
   } else if (appContext.shopId === '6756ce22e9eb64be1d79e135') {
      return <LaRougePage/>
   } else if (appContext.shopId === '65843c79352608b7c26ee1d7') {
      return <SkagenClothingPage/>
   } else if (appContext.shopId === '60d1a17a9f00980033b2582e'
      || appContext.shopId === '68500da01cd84fdbb13d7b7a'
      || appContext.shopId === '68500d2e1cd84fdbb13d75e0') {
      return <GaiLisva/>
   } else if (appContext.shopId === '62d664367f2637370b5484df') {
      return <KintobePage/>
   } else if (appContext.shopId === '66b9bea8b65d1df430d9f0b1') {
      return <MoshiPage/>
   } else if (appContext.shopId === '659e76d499ecc460eae4ceea') {
      return <RabensPage/>
   } else if (appContext.shopId === '61370cb0bf78bb00322c54e6') {
      return <MarkbergPage/>
   } else if (appContext.shopId === '64479e636449ba3b47820dec' ||
      appContext.shopId === '67c04d3638d36af2c9bb4add') {
      return <NorthernHuntingPage/>
   } else if (appContext.shopId === '63399241f9ae58b77afd9d71') {
      return <WheatPage/>
   } else if (appContext.shopId === '64993945a2a3e9ef3301f9f4'
      || appContext.shopId === '64993bc6a2a3e9ef3301fe8b'
      || appContext.shopId === '65ac240a1eb886eb4accf9ea') {
      return <ByGreenCottonPage/>
   } else if (appContext.shopId === '65a599d454170c877f772d3f'
      || appContext.shopId === '65a59a11400b4cd3bf464e5b'
      || appContext.shopId === '65a59a7a400b4cd3bf464fb4') {
      return <MinimumPage/>
   } else if (appContext.shopId === '6438fef8115629a57d746b9e') {
      return <SpejderSportPage/>
   } else if (appContext.shopId === '61e151e642973e00336c4bc1') {
      return <LesDeuxPage/>
   } else if (appContext.shopId === '64219aae3d85b1c429993cef') {
      return <PompDeLuxPage/>
   } else if (appContext.shopId === '64ba6c0891aeccd0b316123e') {
      return <OutfitPage/>
   } else if (appContext.shopId === '67336d1ed88a8894f1fe900b') {
      return <MoonboonPage/>
   } else if (appContext.shopId === '64e5f0de9e05e0552c4cb163') {
      return <LuksusbabyPage/>
   } else if (appContext.shopId === '67066da390e8b69c927e1f8d'
      || appContext.shopId === '67066dee9209ee57d3019529'
      || appContext.shopId === '67066e1990e8b69c927e2ba6'
      || appContext.shopId === '67066e4e90e8b69c927ec2cc') {
      return <RoccamorePage/>
   } else if (appContext.shopId === '66feafab73528f7a24405714'
      || appContext.shopId === '66feaa7773528f7a243fca23') {
      return <PitayaPage/>
   } else if (showLoginOptions) {
      return <PublicPageDefault/>
   } else {
      return <LoginPage/>
   }
}

export const PublicPageDefault: FC<any> = () => {
   const localizations = useRecoilValue(LocalizationsAtom);
   const locale = useRecoilValue(LocaleAtom);
   const navigate = useNavigate();
   const [register] = usePublicPageConsumerCreateMutation()
   const appContext = useRecoilValue(AccessContextData);
   const appData = useRecoilValue(AppDataAtom);
   const [loginType, setLoginType] = useState<'login' | 'wholesale' | undefined>();
   const setLoginContext = useSetRecoilState(LoginContext)

   const classes = useStyles();

   async function registerNewUser() {
      const countries = CountryMapFactory.getCountriesFromDomain(window.location.hostname)
      const country = countries?.[0]?.alpha2 || undefined

      const consumer = await register({
         variables: {
            shopId: appContext.shopId,
            locale: locale,
            country: window.Shopify?.country || window.tradeInSession?.countryCode || country,
            currency: appContext.currency || window.Shopify?.currency?.active || window.tradeInSession?.currency
         }
      });
      if (consumer.data?.ConsumerCreate?.accessToken) {
         setLoginContext({
            accessToken: consumer.data.ConsumerCreate.accessToken
         })
         navigate(ReturnsPagePath());
      }
   }

   const onStart = async () => {
      if (appContext.disableLogin || appData.productSearchEnabled) {
         await registerNewUser();
      } else {
         if (!loginType) {
            navigate(LoginPagePath());
         } else if (loginType === 'login') {
            navigate(LoginPagePath());
         } else if (loginType === 'wholesale') {
            await registerNewUser();
         }
      }
   }

   let showLoginOptions = appData.wholeSaleActive && !appContext.disableLogin && !appData.productSearchEnabled;

   return <PublicRenderer>
      <StyledTypography variant={"h1"} className={classes.title}>
         {localizations.publicPageTitle}
      </StyledTypography>
      <StyledTypography variant={"body1"}>
         {localizations.publicPageDescription}
      </StyledTypography>
      <StyledTypography variant={"body1"}>
         {localizations.publicPageDescription2}
      </StyledTypography>
      {showLoginOptions && <div className={classes.tradeInBoxContainer}>
         <TradeInBox id={"login"} title={localizations.publicPageLoginTitle}
                     description={localizations.publicPageLoginDescription}
                     onClick={() => setLoginType("login")}
                     image={Images.TRADEIN_DTC}
                     selected={loginType === 'login'}
         />
         <TradeInBox id={"wholesale"} title={localizations.publicPageWholeSaleTitle}
                     description={localizations.publicPageWholeSaleDescription}
                     onClick={() => setLoginType("wholesale")}
                     image={Images.TRADEIN_RETAILER}
                     selected={loginType === 'wholesale'}
         />
      </div>}
      <div className={classes.buttonContainer}>
         <StyledButton disabled={showLoginOptions && !loginType} styletype={"front"} className={classes.button}
                       onClick={onStart}>
            {localizations.publicPagePageStartButton}
         </StyledButton>
      </div>
   </PublicRenderer>
}


const useStyles = makeStyles({
   title: {
      marginBottom: '20px'
   },
   tradeInBoxContainer: {
      display: 'flex',
      flexDirection: 'column',
      gap: '20px'
   },
   buttonContainer: {
      display: 'flex',
      alignItems: 'start'
   },
   button: {
      marginTop: '25px',
      width: '250px',
      marginBottom: '40px'
   },
   '@media only screen and (max-width: 800px)': {
      buttonContainer: {
         alignItems: 'center',
         justifyContent: 'center'
      },
   }
});
